<div class="navigation-row-container bg-primary container" [ngClass]="{ 'at-end': isNavAtEnd, 'kid-nav-row': isKid }">
  <div class="row flex-nowrap overflow-auto" (scroll)="onNavScroll($event)">
    <div class="nav-widget" [routerLink]="'/rewards/raffles'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons">redeem</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.rewards' | translate }}
      </div>
    </div>

    <div class="nav-widget" [routerLink]="'/challenges'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons">emoji_events</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.challenges' | translate }}
      </div>
    </div>

    <div class="nav-widget" [routerLink]="'/games'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons material-symbols-outlined">stadia_controller</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.games' | translate }}
      </div>
    </div>
    <div class="nav-widget" [routerLink]="'/gallery'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons material-symbols-outlined">animated_images</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.gallery' | translate }}
      </div>
    </div>
    <ng-container *inPopulation="[populations.Kids]">
      <div class="nav-widget" [routerLink]="'/worksheet'">
        <div class="w-100 d-flex justify-content-center">
          <div class="nav-icon gloss icon material-icons material-symbols-outlined">tactic</div>
        </div>
        <div class="font-size-14 text-center">
          {{ 'nav.worksheet' | translate }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
